import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

interface Parameter {
    isOrderDetailsFieldCompletedValue: boolean;
}

type HandlerType = CustomHandler<Parameter>;

export const CenSpcOrderDetailsFieldCompleted: HandlerType = props => {
    props.dispatch({
        type: "Pages/OnePageCheckout/CenSpcOrderDetailsFieldCompleted",
        isOrderDetailsFieldCompletedValue: props.parameter.isOrderDetailsFieldCompletedValue,
    });
};

export const chain = [CenSpcOrderDetailsFieldCompleted];

const cenSpcOrderDetailsFieldCompleted = createHandlerChainRunner(chain, "CenSpcOrderDetailsFieldCompleted");
export default cenSpcOrderDetailsFieldCompleted;
